import React, { useEffect, useState } from "react";
import { Card, Row, Col, Statistic, List, Avatar, Badge, Empty, Button } from "antd";
import { ShoppingCartOutlined, GiftOutlined, ArrowRightOutlined, ThunderboltOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next"; // ✅ i18n
import { getUserTransactions } from "../../../services/dashboardclient/dashboardclient";

const Overview = ({ userData, getStatusColor, handleTabChange }) => {
  const { t } = useTranslation();
  const [summary, setSummary] = useState({});

  useEffect(() => {
    let active = true;
    getUserTransactions({})
      .then((res) => { if (active) setSummary(res?.summary || {}); })
      .catch(() => { /* stats are non critical */ });
    return () => { active = false; };
  }, []);

  return (
    <div>
      <section className="client-hero">
        <div>
          <span className="client-hero-eyebrow"><ThunderboltOutlined /> {t('Your game. Your next level.', { defaultValue: 'Your game. Your next level.' })}</span>
      <h1>
        {t("Welcome_back")}, {userData.username}!
      </h1>
          <p>{t('Manage your orders, track your balance, and make your next move.', { defaultValue: 'Manage your orders, track your balance, and make your next move.' })}</p>
        </div>
        <Button onClick={() => handleTabChange('home')}>{t('Explore the store', { defaultValue: 'Explore the store' })} <ArrowRightOutlined /></Button>
      </section>

      <Row className="client-stat-grid" gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <span className="client-stat-icon"><ShoppingCartOutlined /></span>
            <Statistic
              title={t("Number_of_Purchases")}
              value={summary.nombre_achats || 0}
              valueStyle={{ color: "var(--client-accent)" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <span className="client-stat-icon"><ThunderboltOutlined /></span>
            <Statistic
              title={t("Number_of_Sales")}
              value={summary.nombre_ventes || 0}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Card>
            <span className="client-stat-icon"><GiftOutlined /></span>
            <Statistic
              title={t("Active_Coupons")}
              value={userData.availableCoupons ? userData.availableCoupons.length : 0}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title={t("Recent_Orders")} style={{ marginBottom: 24 }}>
            {userData.recentOrders && userData.recentOrders.length > 0 ? (
              <>
                <List
                  itemLayout="horizontal"
                  dataSource={userData.recentOrders.slice(0, 3)}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar icon={<ShoppingCartOutlined />} />}
                        title={item.product || t("Unknown_Product")}
                        description={`${t("Ordered_on")} ${item.date || t("Unknown_Date")}`}
                      />
                      <div>
                        <Badge
                          status={getStatusColor(item.status)}
                          text={item.status || t("Unknown")}
                        />
                      </div>
                    </List.Item>
                  )}
                />
                <div style={{ marginTop: 16, textAlign: "center" }}>
                  <Button type="primary" onClick={() => handleTabChange("orders")}>
                    {t("View_All_Orders")}
                  </Button>
                </div>
              </>
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t("No_Orders_Yet")}
              />
            )}
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card title={t("Available_Coupons")}>
            {userData.availableCoupons && userData.availableCoupons.length > 0 ? (
              <>
                <List
                  itemLayout="horizontal"
                  dataSource={userData.availableCoupons}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            icon={<GiftOutlined />}
                            style={{ backgroundColor: "#87d068" }}
                          />
                        }
                        title={item.code || t("Unknown_Code")}
                        description={`${t("Expires")}: ${item.validUntil || t("Unknown")}`}
                      />
                      <div>{item.discount || t("No_discount")}</div>
                    </List.Item>
                  )}
                />
                <div style={{ marginTop: 16, textAlign: "center" }}>
                  <Button type="primary" onClick={() => handleTabChange("coupons")}>
                    {t("View_All_Coupons")}
                  </Button>
                </div>
              </>
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t("No_Coupons_Yet")}
              />
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Overview;
